const CONSENT_KEY = 'nido_privacy_choice_v1';
const HISTORY_KEY = 'nido_recent_property_searches_v1';
const MAX_SEARCHES = 8;

function readHistory() {
  try {
    const parsed = JSON.parse(localStorage.getItem(HISTORY_KEY) || '[]');
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function rememberPropertySearch(queryString, total = 0) {
  if (localStorage.getItem(CONSENT_KEY) !== 'accepted') return;
  const params = new URLSearchParams(queryString);
  params.delete('page');
  params.delete('limit');
  params.delete('sort');
  const query = params.toString();
  if (!query) return;

  const history = readHistory().filter((item) => item.query !== query);
  history.unshift({
    query,
    total: Math.max(0, Number(total) || 0),
    searchedAt: new Date().toISOString(),
  });
  localStorage.setItem(HISTORY_KEY, JSON.stringify(history.slice(0, MAX_SEARCHES)));
}

export function getRecentPropertySearches(limit = 3) {
  if (localStorage.getItem(CONSENT_KEY) !== 'accepted') return [];
  return readHistory()
    .filter((item) => item?.query && !Number.isNaN(Date.parse(item.searchedAt)))
    .sort((a, b) => Date.parse(b.searchedAt) - Date.parse(a.searchedAt))
    .slice(0, Math.max(1, limit));
}

export function describePropertySearch(queryString) {
  const params = new URLSearchParams(queryString);
  const location = params.get('neighborhood')
    || params.get('department')
    || params.get('location')
    || params.get('province');
  const type = params.get('type');
  const operation = params.get('operation');

  if (location) return String(location).replace(/_/g, ' ');
  if (type) return String(type).replace(/_/g, ' ');
  if (operation) return operation === 'venta' ? 'propiedades en venta' : String(operation).replace(/_/g, ' ');
  return 'tus búsquedas recientes';
}
